<template>
    <div>
        <select id="document-type" class="custom-select" v-bind:class="['mb-3', { 'text-muted' : selectedId === 0 }]" v-model="selectedId" @change="select($event)">
            <option disabled hidden value="0">What type of document is it?</option>
            <option v-for="option in documentTypes" :key="'document-type-' + option.id" :value="option.id" v-text="option.name"></option>
        </select>
        <input type="text" class="form-control mb-3" placeholder="Description" v-model="desc" @input="$emit('update:description', desc)">
        <select id="association-type" class="custom-select" v-bind:class="['mb-3', { 'text-muted' : associationId === 0 }]" v-model="associationId" @change="select($event)">
            <option disabled hidden value="0">What do you want to associate the document with?</option>
            <option v-for="option in associationTypes" :key="'association-type-' + option.id" :value="option.id" v-text="option.name"></option>
        </select>    
    </div>
</template>

<script>
import { DocumentType, AssociationType } from '../../constants.js';

export default {
    props: {
        documentType: Object,
        description: String,
        associationType: Number
    },
    data() {
        return {
            selectedId: this.documentType ? this.documentType.id : 0,
            desc: this.description,
            associationId: this.associationType,
            documentTypes: [],

            // import constants into the template
            DocumentType: DocumentType,
            AssociationType: AssociationType,

            associationTypes: [
                {id: AssociationType.CLAIM, name: 'Claim'},
                {id: AssociationType.DOCUMENT, name: 'Document'}
            ],            
        }
    },
    methods: {
        select: function (e) {
            if (e.target.id === 'document-type') {
                let documentType = this.documentTypes.find(obj => { return obj.id == e.target.value; });
                this.$emit('update:documentType', documentType);

                // reset association type
                this.associationId = 0;
                this.$emit('update:associationType', AssociationType.DOCUMENT);
            }
            else if (e.target.id === 'association-type') {
                let associationType = this.associationTypes.find(obj => { return obj.id == e.target.value; });
                this.$emit('update:associationType', associationType.id);
            }
        }
    },
    created() {
        axios.get('/ajax/inbox/document-types')
            .then(response => {
                this.documentTypes = response.data;
            })
            .catch(error => {
                // TODO: handle error
            });        
    }
}
</script>

<style scoped>

</style>